import { useState, useEffect } from 'react';

import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';

interface ThemedSrc {
	light: string;
	dark: string;
}

export const usePreloadGif = ({
	gif,
	placeholder,
	skip = false,
}: {
	gif: ThemedSrc;
	placeholder: ThemedSrc;
	skip?: boolean;
}): string => {
	const { colorMode } = useThemeObserver();
	const gifSrc = gif[colorMode ?? 'light'];
	const placeholderSrc = placeholder[colorMode ?? 'light'];

	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		if (skip) {
			return;
		}

		setIsReady(false);

		const image = new Image();

		image.onload = () => {
			setIsReady(true);
		};

		image.onerror = () => {
			setIsReady(false);
		};

		image.src = gifSrc;

		// If the image has already loaded (cached), handle it immediately
		if (image.complete) {
			setIsReady(true);
		}
	}, [gifSrc, skip]);

	return isReady ? gifSrc : placeholderSrc;
};
